module.exports = __webpack_public_path__ + "img/purpose_refinancing.59913543.svg";